import { configureStore } from "@reduxjs/toolkit";
import global from "store/reducers/global";
import user from "store/reducers/user";
import chat from "store/reducers/chat";
import task from "store/reducers/task";
import notice from 'store/reducers/notice';
import addressBook from 'store/reducers/addressBook';
import form from 'store/reducers/form';
import profile from 'store/reducers/profile';
import knowledge from 'store/reducers/knowledge';
import score from 'store/reducers/score';
import setting from 'store/reducers/setting';
import intl from 'store/reducers/intl';
import login from 'store/reducers/login';
import theme from 'store/reducers/theme';

const store = configureStore({
  reducer: {
    global,
    chat,
    task,
    user,
    addressBook,
    notice,
    form,
    profile,
    knowledge,
    score,
    setting,
    intl,
    login,
    theme
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
